export function ContactUs() {
  return (
    <p className="text-center mt-2 text-sm font-bold">
      <a
        href="https://qm.qq.com/q/nCE7JVP9ZY"
        className="px-2 underline text-blue-500"
        target="_blank"
        rel="noreferrer"
      >
        遇到问题？ 进群吐槽
      </a>
    </p>
  );
}
